export const Marquee = ({ text }) => (
  <div data-testid="editorial-marquee" className="bg-[#EBE7DF] border-y border-[#C29B62]/20 py-6 overflow-hidden">
    <div className="animate-marquee-slow flex whitespace-nowrap w-max">
      {[0, 1].map((n) => (
        <span key={n} className="font-serif-display text-2xl lg:text-3xl font-light text-[#1C3829] pr-24">
          {text.repeat(4)}
        </span>
      ))}
    </div>
  </div>
);
